import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { InvoiceSettingRequest } from '@business/entities/invoiceSetting';
import { EmailTemplateAPI } from '@business/api/subcontractor_email_template';
import { SubcontractorEmailTemplateResponse } from '@business/entities/subcontractorEmailTemplate';
import { EmailTemplateSettingsFormData, EmailTemplateSettingsFormType } from '@modules/settings/SettingsPage/Components/SubcontractorTab/Tabs/SubContractorEmailTemplate';

export class SubContractorEmailTemplateBloc extends BaseBloc {
  private readonly emailTemplateRepo = new Repository<SubcontractorEmailTemplateResponse>({
    getItemId: item => item.id,
  });

  readonly settings = this.emailTemplateRepo.selectItem;

  onReset() {
    this.emailTemplateRepo.reset();
  }

  fetchSettings = () => {
    return EmailTemplateAPI.fetchSettings().pipe(
      this.emailTemplateRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_subcontractor_email_template_error') }),
    );
  };

  saveSettings = (data: EmailTemplateSettingsFormData) => {
    return EmailTemplateAPI.saveSettings(data).pipe(
      this.emailTemplateRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('create_email_template'),
      }),
    );
  };
}
